import { Box } from '@chakra-ui/react';
import React from 'react';

const BVInline = ({ productSlug, small = false, dataBvSeo = true }) => {
  const transformedName = productSlug
    .toLowerCase()
    .trim()
    .replace(`product-`, ``)
    .replace(/[%]|w\/w/g, ``)
    .replace(/ +/g, `-`);

  return (
    <Box
      mt="1"
      data-bv-show="inline_rating"
      data-bv-product-id={`product-${transformedName}`}
      data-bv-seo={dataBvSeo}
      sx={
        small && {
          'span svg': {
            transform: `scale(0.8)!important`
          },
          'div[class="bv_averageRating_component_container"] div[class="bv_text"], div[class="bv_numReviews_component_container"] div[class="bv_text"]':
            {
              fontSize: `14px!important`
            }
        }
      }
    />
  );
};

export default BVInline;
